import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as passwordActions from '../../../actions/password';

class InitPassword extends React.Component {
	componentDidUpdate() {
		if (Object.keys(this.props.userInfo).length) {
			this.props.initPassword();
		}
	}

	componentDidMount() {
		if (Object.keys(this.props.userInfo).length) {
			this.props.initPassword();
		}
	}

	render() {
		return null;
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, passwordActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InitPassword);



// WEBPACK FOOTER //
// ./app/components/security/password/InitPassword.js